import React from 'react'
import styles from './styles.css'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import Button from 'orionsoft-parts/lib/components/Button'
import {withRouter} from 'react-router'
import cloneDeep from 'lodash/cloneDeep'
import Error from './Error'

const maxMasivos = 10;
const kick=true;

@withRouter
@withMutation(gql`
  mutation massiveUp($templateId: String, $xlsxObject: JSON) {
    massiveUp(templateId: $templateId, xlsxObject: $xlsxObject)
  }
`)
@withMessage
export default class SendMassiveContract extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    data: PropTypes.array,
    templateId: PropTypes.string,
    showMessage: PropTypes.func,
    withRouter: PropTypes.func,
    massiveUp: PropTypes.func
  }

  state = {
    failed: [],
    sended: false
  }
  

  @autobind
  async massiveSend() {
    console.log("Vamos");
    this.setState({loading: true, errorMessages: null})
    var massiveUps = [];
    try {
      console.log("viene xlsxData");
      //console.log("xlsxData: ", this.props.data);
      
      var errores = [];

      for (let i = 0; i < this.props.data.length; i += maxMasivos) {
        const chunk = this.props.data.slice(i, i + maxMasivos);
        //console.log("Procesando chunk"+i, chunk);

       let miniResponse = await this.props.massiveUp(
          {templateId: this.props.templateId, xlsxObject: chunk},
          {
            refetchQueries: [ 'myDocumentsToSign', 
                              'myFeaDocumentsToSign',
                              'documentCount', 
                              'organizationDocCount',
                              'planSignaturesCount',
                              'packsSignaturesCount'
                            ]
          }
        )
        //console.log("miniResponse pre", miniResponse);
        if( miniResponse && miniResponse.massiveUp && miniResponse.massiveUp.length > 0){
          for(let h=0; h<miniResponse.massiveUp.length; h++){
            miniResponse.massiveUp[h].fila = miniResponse.massiveUp[h].fila +i;
          }
          //console.log("miniResponse post", miniResponse);
          massiveUps = massiveUps.concat(miniResponse.massiveUp);
        }
        //console.log("massiveUps hasta ahora: ", massiveUps);
        let total = i + chunk.length ;
        this.props.showMessage('Enviados ' + total + ' documentos')
        
      }
      let response = {
        massiveUp: massiveUps
      }
      //console.log("Response final a mostrar", response);
      this.setState({response, sended: true})
      this.props.showMessage('Todos los documentos enviados')
      return null
    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
      console.log('Error:', error)
      const failed = cloneDeep(this.state.failed)
      this.setState({failed: failed})
    }
    this.setState({loading: false})
  }

  renderButton() {
    return (
      <div className={styles.button}>
        <Button
          primary
          disabled={!this.props.data}
          loading={this.state.loading}
          onClick={() => this.massiveSend()}
        >
          Enviar Documentos
        </Button>
      </div>
    )
  }

  render() {
    
    if (this.props.data) {
      console.log("Excel cargado");
    }
    return (
      <div className={styles.container}>
        {!this.state.sended ? this.renderButton() : null}
        {this.state.sended ? (
          <Error data={this.state.response.massiveUp} sended={this.state.sended} />
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/MassiveCreate/SendMassiveContract/index.js